import { Row, Col, Image } from 'react-bootstrap';

const SecondaryLayout = ({ children }) => (
  <div className="position-relative d-flex align-items-center flex-column w-100 min-vh-100 bg-dark">
    <Image src="/images/vector-left.png" className="position-absolute bottom-0 start-0 mw-100 h-100" />
    <Image src="/images/vector-right.png" className="position-absolute top-0 end-0 mw-100 h-100" />
    <div className="w-100 px-sm-40 px-md-80 py-24 mh-100 mw-100">
      <Row className="mh-100">
        <Col xs={1} sm={2} xl={3} className="mh-100" />
        <Col xs={10} sm={8} xl={6} className="mh-100">
          <div className="d-lg-block d-flex flex-column justify-content-center w-100 px-xxxl-112 px-xl-0">
            {children}
          </div>
        </Col>
      </Row>
    </div>
  </div>
);

export default SecondaryLayout;
